import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useParams } from "react-router-dom";
import programs from "../programs_offered/programsData.js";
import AdmissionFormModal from "../../../components/AdmissionFormModal/AdmissionFormModal.jsx";

const ProgramDetails = ({ section }) => {
  const { programId } = useParams();
  const [showBrochure, setShowBrochure] = useState(false);

  const program = programs.find((p) => p.id === programId);

  if (!program) return <h2>Program not found</h2>;

  const handleSubmit = (formData) => {
    console.log("User Data:", formData);

    // open brochure after form submit
    window.open(program.brochure, "_blank");

    setShowBrochure(false);
  };

  if (!program) return <h2>Program not found</h2>;

  return (
    <div>
      <h1 className="title">{program.title}</h1>
      <hr />

      <div className="prog-off-content">
        {/* Section 1: Image + Info */}
        <div className="prog-off-info-section">
          <div className="prog-off-image">
            <img src={program.image} alt={program.title} />
          </div>

          <div className="prog-off-content">
            <p>
              <b className="innerpage-subheading">Eligibility:</b>
              {program.eligibility}
            </p>
            <p>
              <b className="innerpage-subheading">Duration:</b>
              {program.duration}
            </p>
            <p>
              <b className="innerpage-subheading">Age (max):</b> {program.age}
            </p>
            <p>
              <b className="innerpage-subheading">Intake:</b> {program.intake}
            </p>
          </div>
        </div>

        {program.descriptionSections.map((sec, i) => (
          <div key={i}>
            {sec.heading && (
              <h4 className="innerpage-subheading">{sec.heading}</h4>
            )}

            {/* Paragraph */}
            {typeof sec.text === "string" && <p>{sec.text}</p>}

            {/* Bullet list */}
            {Array.isArray(sec.text) && (
              <ul className="page-content-lists">
                {sec.text.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            )}

            {/* Companies two column list */}
            {sec.companies && (
              <div
                className="sponsor-company"
              >
                <ul className="page-content-lists">
                  {sec.companies.col1.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>

                <ul className="page-content-lists">
                  {sec.companies.col2.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}

        {/* Section 3 */}
        <div className="prog-off-cards-section">
          <h4 className="innerpage-subheading">Career Path:</h4>
          <div className="prog-off-cards">
            {program.careerCards.map((card, i) => (
              <div className="prog-off-card" key={i}>
                <h5>{card.title}</h5>
                <p>{card.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Section */}
        <div className="prog-off-bottom">
          <div
            className="page-content-note"
            style={{ margin: "clamp(10px ,2vw,20px) 0" }}
          >
            <p> Ready to sail towards a prosperous future?</p>
            <p> The best college for B. Tech in Marine Engineering!</p>
          </div>
          <Link to="/admissions/admission-2026">
            <button>Apply Now</button>
          </Link>

          <AdmissionFormModal
            isOpen={showBrochure}
            onClose={() => setShowBrochure(false)}
            onSubmit={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgramDetails;
